// Flag apagado en lugar de borrar código/rutas.
export const INTERNATIONAL_SECTION_ENABLED = false;

export const SIDEBAR_PATHS = {
  integrations: 'https://developers.99minutos.com/page/integrate-your-business',
  p99: {
    aboutP99: 'https://www.99minutos.com/punto99/',
    locations: 'https://network.punto99.com/',
  },
};

export const GO_DOCUMENTATION = {
  developers: 'https://developers.99minutos.com',
  webhooks: 'https://developers.99minutos.com/reference/post-api-v3-webhooks',
  createOrder: 'https://developers.99minutos.com/reference/orders_create',
};
